import Ping from './ping';

const baseUrl = '/umbraco/api/';

const ApiHelpers = {
	async request(method, url, params = {}, body = null, callback, errorCallback, antiForgeryToken) {
		const query = new URLSearchParams(params).toString();
		const fullUrl = query ? `${baseUrl}${url}?${query}` : `${baseUrl}${url}`;

		// Get anti-forgery token from hidden input field if not provided
		if (!antiForgeryToken) {
			const tokenElement = document.querySelector('input[name="__RequestVerificationToken"]');
			// eslint-disable-next-line no-param-reassign
			antiForgeryToken = tokenElement ? tokenElement.value : '';
		}

		const options = {
			method,
			headers: {
				'Content-Type': 'application/json',
				Culture: document.documentElement.lang,
				RequestVerificationToken: antiForgeryToken,
			},
		};

		if (body) {
			options.body = JSON.stringify(body);
		}

		try {
			const response = await fetch(fullUrl, options);
			const data = await response.json();

			if (!response.ok) {
				throw data;
			}

			if (data?.ping) {
				Ping.createHappyPing(data.ping.pingHeading, data.ping.pingBody);
			}

			if (callback) {
				callback(data);
			}

			return data;
		} catch (data) {
			if (data?.ping) {
				Ping.createPing(data.ping.pingHeading, data.ping.pingBody, data.ping.pingEmotion);
			}

			if (data?.error) {
				Ping.createSadPing(null, data.error.message);
			}

			if (errorCallback) {
				errorCallback();
			}

			throw data;
		}
	},

	get(url, params = {}, callback, errorCallback, antiForgeryToken = '') {
		return this.request('GET', url, params, null, callback, errorCallback, antiForgeryToken);
	},

	post(url, body = {}, callback, errorCallback, antiForgeryToken = '') {
		return this.request('POST', url, {}, body, callback, errorCallback, antiForgeryToken);
	},

	delete(url, params = {}, callback, errorCallback, antiForgeryToken = '') {
		return this.request('DELETE', url, params, null, callback, errorCallback, antiForgeryToken);
	},
};

export default ApiHelpers;
